import { AppType } from "@/features/applications";

import { Radio, Row, Typography } from "antd";
import React from "react";

import { WatchlistTab, WatchlistType } from "../types";
import { defaultTab } from "./constants";
import styles from "./styles.less";
import { useWatchListUpdate } from "@/features/applications/hook";

const { Paragraph } = Typography;

interface IProps {
  selectedWatchlist: string;
  setActiveKey: (e: string) => void;
  setPanes: (e: WatchlistTab[]) => void;
  setTableType: (e: WatchlistType) => void;
  tableType: WatchlistType;
  paneKey: string;
}

export default ({ selectedWatchlist, setActiveKey, setPanes, setTableType, tableType, paneKey }: IProps) => {
  const { userWatchlist, updateWatchlist } = useWatchListUpdate();

  if (paneKey === "all") return null;

  return (
    <Row justify="start">
      <Paragraph underline strong editable={{ onChange: renameWatchlist }} style={{ margin: 0, fontSize: 18 }}>
        {selectedWatchlist}
      </Paragraph>
      <Radio.Group onChange={e => setTableType(e.target.value)} value={tableType} className={styles.stockRadioSelect}>
        <Radio value="watchlist">Watchlist</Radio>
        <Radio value="alert">Alert Limits</Radio>
      </Radio.Group>
    </Row>
  );

  function renameWatchlist(newName: string) {
    let newWatchlist = {};

    //Reserve the order while renaming the key
    Object.keys(userWatchlist).forEach(name => {
      if (name === selectedWatchlist) {
        let newPair = { [newName]: userWatchlist[selectedWatchlist] };
        newWatchlist = { ...newWatchlist, ...newPair };
      } else {
        newWatchlist = { ...newWatchlist, [name]: userWatchlist[name] };
      }
    });

    updateWatchlist(newWatchlist);
    setPanes(getDefaultWatchlist(newWatchlist));
    setActiveKey(newName);
  }

  function getDefaultWatchlist(newWatchlist: Record<string, AppType.TickerExchange[]>): WatchlistTab[] {
    return [
      ...defaultTab,
      ...Object.keys(newWatchlist).map(k => ({
        title: k,
        content: newWatchlist[k],
        key: k,
        closable: true
      }))
    ];
  }
};
